import PropTypes from 'prop-types';

const ToggleSwitch = ({ onChange, checked }) => {
  return (
    <label class="switch">
      <input type="checkbox" onChange={onChange} checked={checked} />
      <span class="slider round"></span>
    </label>
  );
};

ToggleSwitch.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool
};
export default ToggleSwitch;
